import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router";
import API from "../../../services";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface CustomerSupportProps {

}


const TicketDetails: React.FC<CustomerSupportProps> = ({ }) => {
    const location = useLocation();
    const { details, ticketId } = location.state || {};
    const [newTicket, setNewTicket] = useState<any>(false);
    const [newTicDes, setNewTicDes] = useState<any>("");
    const navigate = useNavigate();
    const isFirstRender = useRef(true);
    const [ticDetails, setTicDetails] = useState<any>();
    const [selectedImages, setSelectedImages] = useState<File[]>([]);
    const [previews, setPreviews] = useState<string[]>([]);
    const [expImg, setExpImg] = useState<any>(false);
    const [selectedUrl, setSelectedUrl] = useState<any>("");
    const [loadSubmit, setLoadSubmit] = useState<any>(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const dateFormat = (time: any) => {
        const matchStartTime = new Date(time * 1000);

        const formattedStartTime = matchStartTime.toLocaleString("en-GB", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
        });

        return formattedStartTime
    }


    const handleBackClick = () => {
        navigate(-1);
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (!e.target.files || e.target.files.length === 0) {
            console.log("No files selected");
            return;
        }

        const files = Array.from(e.target.files);
        console.log("Files selected:", files);

        const validFiles = files.filter(file => file.size < 1024 * 1024); // Ensure size < 1MB
        if (validFiles.length === 0) {
            toast.info("Only images less than 1MB are allowed.");
            return;
        }

        setSelectedImages((prevImages) => [...prevImages, ...validFiles]);
        setPreviews((prevPreviews) => [
            ...prevPreviews,
            ...validFiles.map((file) => URL.createObjectURL(file)),
        ]);

        // Fix: Reinitialize file input to ensure event triggers on next selection
        resetFileInput();
    };

    const removeImage = (index: number) => {
        setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    };

    const resetFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            const newInput = fileInputRef.current.cloneNode(true) as HTMLInputElement;
            fileInputRef.current.replaceWith(newInput);
            fileInputRef.current = newInput;

            // Fix: Wrap handleImageChange inside an event listener conversion
            fileInputRef.current.addEventListener("change", (evt) => {
                handleImageChange(evt as unknown as React.ChangeEvent<HTMLInputElement>);
            });
        }
    };

    const getSupportTicket = async () => {
        // if (isFirstRender.current) {
        //     setLoading(true);
        //     isFirstRender.current = false;
        // }

        let response;
        try {
            response = await API.post(`/webapp/get-ticket`, {
                ticketId: ticketId
            });
        } catch (e) {
            console.log(e);
            // setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            navigate("/home");
        }

        if (response && response.data?.ticket) {
            setTicDetails(response?.data?.ticket)
        }
        // setLoading(false);
    };

    useEffect(() => {
        if (details) {
            setTicDetails(details)
        }

        if (ticketId) {
            getSupportTicket();
        }
    }, [details, ticketId]);

    const handleWithDrawSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setLoadSubmit(true);

        const formData = new FormData();


        selectedImages.forEach((image, index) => {
            formData.append(`images`, image);
        });

        // Create the payload for category and description
        const payload = {
            comment: newTicDes,
            status: ticDetails?.Status,
            ticketId: ticDetails?.TicketId
        };

        // Append the JSON payload to the FormData (as a string)
        formData.append("messageData", JSON.stringify(payload));



        try {
            const response = await API.post(`/webapp/update-support-ticket`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            const data = response.data;
            if (data?.status !== "RS_OK") {
                toast.error(`${data.errorDescription}`);
                return;
            } else {
                toast.success("Ticket Updated Successfully");
                navigate("/customersupport");
            }
            setNewTicDes("");
            setNewTicket(false);

        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            setLoadSubmit(false);
        }
    };

    return (
        <>
            <div className="flex flex-col px-3 mt-4 w-full pb-[7rem] py-[4rem] customer-support">
                <header className="flex gap-3 items-center self-start text-base font-medium text-center text-white mb-[0.5rem] w-full justify-between">
                    <div>
                        <div className="bg-inputbox-color flex p-1 mr-[0.25rem] rounded"
                            onClick={() => handleBackClick()}
                        >
                            <ArrowBackIcon
                                className="text-border-color aspect-square w-[18px]"
                                style={{ width: '20px', height: '20px' }}
                            />
                        </div>
                    </div>
                    <h2 className="self-stretch my-auto">Ticket Details</h2>
                    <button
                        onClick={() => setNewTicket(true)}
                        className="flex items-center justify-between px-3 py-2 text-xs font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-slate-800"
                    >
                        <span>+ New Comment</span>
                    </button>
                </header>
                <div className="p-2">
                    <div className="mb-4">
                        <p className="text-base font-medium ">TicketId</p>
                        <div className="p-1">
                            <p className="text-sm  text-white">{ticDetails?.TicketId}</p>
                        </div>
                    </div>

                    <div className="mb-4">
                        <p className="text-base font-medium ">Created At</p>
                        <div className="p-1">
                            <p className="text-sm  text-white">{dateFormat(ticDetails?.CreatedAt)}</p>
                        </div>
                    </div>

                    <div className="mb-4">
                        <p className="text-base font-medium">Description</p>
                        <div className="p-1">
                            <p className="text-sm text-white">
                                {ticDetails?.Description}
                            </p>
                        </div>
                        {ticDetails?.Attachments && ticDetails?.Attachments?.map((url: any, index: number) => (
                            <img key={index} src={url} alt={`attachment-${index}`} className="w-16 h-16 object-cover rounded-lg"
                                onClick={() => { setSelectedUrl(url); setExpImg(true) }}
                            />
                        ))}
                    </div>

                    {ticDetails?.ReferenceId && ticDetails?.ReferenceId !== "N/A" && (
                        <div className="mb-4">
                            <p className="text-base font-medium ">Reference Id</p>
                            <div className="p-1">
                                <p className="text-sm  text-white">{ticDetails?.ReferenceId}</p>
                            </div>
                        </div>
                    )}


                    <div className="mb-4">
                        <div className="text-base font-medium">
                            Status: <span className="text-sm text-white font-normal">{ticDetails?.Status}</span>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="text-base font-medium">
                            Category: <span className="text-sm text-white font-normal">{ticDetails?.Category}</span>
                        </div>
                    </div>
                    {
                        (ticDetails?.Updates && ticDetails?.Updates?.length > 0) ? <>
                            <div className="mb-4">
                                <p className="text-base font-medium">Updates:</p>
                                <div className="p-1">
                                    {
                                        ticDetails?.Updates?.map((update: any) => (
                                            <div>
                                                <p className="text-sm  text-white"><strong>{update?.UpdatedBy}: </strong>{update?.Comment}</p>
                                                <div className="grid grid-cols-4">
                                                    {update?.Attachments && update?.Attachments?.map((url: any, index: number) => (
                                                        <img key={index} src={url} alt={`attachment-${index}`} className="w-16 h-16 mb-2 rounded-lg"
                                                            onClick={() => { setSelectedUrl(url); setExpImg(true) }}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </> : <></>
                    }
                </div>


            </div>

            {
                newTicket && (
                    <Dialog
                        fullScreen={false}
                        open={newTicket}
                        onClose={() => setNewTicket(false)}
                        className="frame-dialog"
                        PaperProps={{
                            sx: {
                                position: "absolute",
                                top: "5rem",
                            },
                        }}
                    >
                        <div className="h-dialog-bg bg-inputbox-color relative p-4">
                            <CloseIcon
                                className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                onClick={() => setNewTicket(false)}
                            />
                            <div>
                                <div>
                                    Add A Comment
                                </div>
                                <div>
                                    <>
                                        <form className="flex flex-col w-full" onSubmit={handleWithDrawSubmit}>
                                            <label
                                                htmlFor="amount"
                                                className="block mt-2 text-sm text-zinc-400"
                                            >
                                                Comment
                                            </label>
                                            <input
                                                type="text"
                                                className="px-4 py-3 mt-2.5 w-full text-sm font-medium text-white placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem]"
                                                placeholder="Enter you Issue"
                                                value={newTicDes || ""}
                                                onChange={(e) => setNewTicDes(e.target.value)}
                                            />

                                            <div>
                                                <label className="block mt-3 text-sm text-zinc-400">Attach Image</label>
                                                <label className="block w-full mt-2 mb-2">
                                                    <input
                                                        id="file-upload"
                                                        ref={fileInputRef}
                                                        type="file"
                                                        accept="image/*"
                                                        // multiple
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => fileInputRef.current?.click()}
                                                        className="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color shadow-sm hover:bg-opacity-80"
                                                    >
                                                        Choose Image
                                                    </button>
                                                </label>
                                                <label className="block text-xs text-zinc-400">*Only images less than 1MB</label>
                                                <label className="block text-xs text-zinc-400">*Note: If unable to upload directly, try uploading by browsing from file</label>

                                                {previews.length > 0 && (
                                                    <div className="grid grid-cols-3 gap-4 mt-2">
                                                        {previews.map((preview, index) => (
                                                            <div key={index} className="relative group">
                                                                <img
                                                                    src={preview}
                                                                    alt={`Preview ${index}`}
                                                                    className="w-24 h-24 object-cover rounded-lg border border-border-color shadow-md"
                                                                />
                                                                <button
                                                                    onClick={() => removeImage(index)}
                                                                    className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center opacity-90 hover:opacity-100 transition"
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex justify-between mt-4">
                                                <button
                                                    type="submit"
                                                    className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                                                    disabled={!newTicDes || loadSubmit}
                                                >
                                                    {loadSubmit ? 'Submitting' : 'Submit'}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                                                    onClick={() => { setNewTicket(false) }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Dialog>
                )
            }

            {
                expImg && (
                    <Dialog
                        fullScreen={false}
                        open={expImg}
                        onClose={() => setExpImg(false)}
                        PaperProps={{
                            style: {
                                position: 'absolute',
                                top: '5rem'
                            }
                        }}
                    >
                        <div className="img-dialog-bg bg-inputbox-color relative p-4">
                            <CloseIcon
                                className="absolute top-3 right-3 text-white text-2xl font-semibold"
                                onClick={() => setExpImg(false)}
                            />
                            <div>
                                <img
                                    src={selectedUrl}
                                    alt="img"
                                />
                            </div>
                        </div>
                    </Dialog>
                )
            }
        </>
    );
};

export default TicketDetails;